require('./angular-messages');
module.exports = 'ngMessages';



//////////////////
// WEBPACK FOOTER
// ./~/angular-messages/index.js
// module id = 85
// module chunks = 0